module.exports = "/_next/static/images/ac36c277381ba763dbebb7e0c9fd6532-2-women-working-landscape@0.5x.jpg.webp";